import FAQAccordion from '@/components/FAQAccordion'
import { faqData } from '@/data/faqData'

function LegalPanel() {
  return (
    <section aria-labelledby="legal-heading" className="max-w-3xl">
      <h1 id="legal-heading" className="text-3xl font-extrabold text-slate-900 mb-2">
        Regulatory Disclaimers & Legal Information
      </h1>
      <p className="text-slate-600 leading-relaxed mb-8">
        Please read the following disclaimers carefully before relying on any calculation, figure, or educational content presented on BioSlick.
      </p>

      <div className="rounded-xl border border-amber-300 bg-amber-50 p-5 mb-8">
        <h2 className="text-lg font-bold text-amber-900 mb-2">Educational Use Disclaimer</h2>
        <p className="text-sm text-amber-900 leading-relaxed">
          All calculators, formulas, and worked examples on BioSlick are provided strictly for educational and reference purposes. Outputs are mathematical model estimates and are <strong>not</strong> validated for clinical, diagnostic, regulatory, or production laboratory use. Always verify results independently using validated laboratory protocols, calibrated instrumentation, and qualified personnel before performing any biological, chemical, or laboratory procedure. BioSlick assumes no liability for outcomes resulting from reliance on this tool.
        </p>
      </div>

      <div className="space-y-6 mb-10">
        <div>
          <h2 className="text-xl font-bold text-slate-900 mb-2">No Professional or Medical Advice</h2>
          <p className="text-sm text-slate-700 leading-relaxed">
            Content on this site does not constitute medical, legal, regulatory, or professional laboratory advice. Consult a qualified biosafety officer, principal investigator, or regulatory affairs professional for guidance specific to your institution and jurisdiction.
          </p>
        </div>
        <div>
          <h2 className="text-xl font-bold text-slate-900 mb-2">Accuracy of Third-Party References</h2>
          <p className="text-sm text-slate-700 leading-relaxed">
            References to databases such as the National Center for Biotechnology Information, and to companies profiled in the Biotech Directory, are provided for illustrative and educational context only. BioSlick is not affiliated with, endorsed by, or sponsored by any referenced organization. Company details may change over time; verify current information directly with official sources.
          </p>
        </div>
        <div>
          <h2 className="text-xl font-bold text-slate-900 mb-2">Limitation of Liability</h2>
          <p className="text-sm text-slate-700 leading-relaxed">
            BioSlick and its operators are not liable for any direct, indirect, incidental, or consequential damages arising from the use or misuse of any calculator, figure, or content presented on this site. Use of this site constitutes acceptance of these terms.
          </p>
        </div>
      </div>

      <div className="border-t border-slate-200 pt-8">
        <h2 className="text-xl font-bold text-slate-900 mb-4">Frequently Asked Questions</h2>
        <FAQAccordion items={faqData} />
      </div>
    </section>
  )
}

export default LegalPanel
